import {StringArray} from '../../@interfaces/types';
import {Constructable} from '../../@types/instantable';
import {RouteAction} from '../../@types/services/Router/RouteAction';
import {ParsedRouteAction} from '../../@types/services/Router/ParsedRouteAction';
import {IControllersRepository} from '../../@interfaces/services/ControllersRepository/IControllersRepository';
import {IController} from '../../@interfaces/services/ControllersRepository/IController';

export default class ControllersRepository implements IControllersRepository {
	protected registeredControllers: StringArray<Constructable<IController>> = {};

	protected controllersCache: StringArray<IController> = {};

	getControllerByName(name: string): IController | null {
		let controllerName = name;
		if (!(controllerName in this.registeredControllers)) {
			controllerName = controllerName.trim().replace(/^.+?/ui, char => char.toUpperCase());

			if (!(controllerName in this.registeredControllers)) {
				return null;
			}
		}

		if (controllerName in this.controllersCache) {
			return this.controllersCache[controllerName];
		}

		const controller = this.resolveController(this.registeredControllers[controllerName]);
		if (controller) {
			this.controllersCache[controllerName] = controller;
		}

		return controller;
	}

	getControllerByRouteAction(routeAction: RouteAction): IController | null {
		return this.getControllerByName(
			this.parseRouteAction(routeAction).controllerName
		);
	}

	parseRouteAction(routeAction: RouteAction): ParsedRouteAction {
		const [controllerName, controllerAction = null] = routeAction.split('@');

		return {controllerName, controllerAction};
	}

	registerController(name: string, constructor: Constructable<IController>): void {
		this.registeredControllers[name] = constructor;
	}

	protected resolveController(controllerConstructor: Constructable<IController>): IController {
		return new controllerConstructor();
	}
}
